import React from 'react'

function BoxPlaceholder (): JSX.Element {
  return (<div className='box' />)
}

export default BoxPlaceholder
